import Http from './axios-config';

class StatisticsService {
    constructor() {
        this.http = new Http();
    }

    async getUsersWithGclid(filters = {}) {
        return await this.http.get('/statistics/users-with-gclid', {
            params: filters
        });
    }
}

export default new StatisticsService();
